"use client";

// @ts-strict-ignore
import styled from "styled-components";

export const Wrapper = styled.div`
  a {
    display: inline-block;
    margin-top: 35px;
    margin-bottom: 35px;

    ${({ theme: { media } }) => media.tablet`
      margin-top: 40px;
    `};
  }

  ${({ theme: { media } }) => media.tablet`
    padding-top: 80px;
    text-align: center;
  `};
`;

export const Headline = styled.h1`
  font-size: 40px;
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  font-stretch: normal;
  font-style: normal;
  margin-top: 0;
  margin-bottom: 16px;
  line-height: 1.3;

  ${({ theme: { media } }) => media.tablet`
    font-size: 80px;
    line-height: 1.3;
    letter-spacing: -2.22px;
    margin-bottom: 26px;
  `};
`;

export const SubHeading = styled.h2`
  font-size: 20px;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: 1.3;
  margin-top: 0;
  margin-bottom: 20px;

  ${({ theme: { media } }) => media.tablet`
    font-size: 36px;
    margin-bottom: 24px;
  `};
`;

export const ReasonHeading = styled.p`
  font-size: 16px;
  margin-top: 0;

  ${({ theme: { media } }) => media.tablet`
    font-size: 24px;
  `};
`;
